// extracted by mini-css-extract-plugin
module.exports = {"Page":"StylePage_Page__3MiHO","Wrap":"StylePage_Wrap__xsLIS","Order":"StylePage_Order__fSU98","NotFound":"StylePage_NotFound__1oyPz"};